import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=06c5bc0f&scoped=true"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=06c5bc0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c5bc0f",
  null
  
)

export default component.exports